import { render } from "./AppIframe.vue?vue&type=template&id=8054eae6"
import script from "./AppIframe.vue?vue&type=script&lang=js"
export * from "./AppIframe.vue?vue&type=script&lang=js"

import exportComponent from "E:\\my-work\\company\\product\\LessonPlay\\lessonplay_shell\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__